/* projects/speaker-platform/src/app/organisms/texts-list/texts-list.component.scss */
.textslist__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
/*# sourceMappingURL=texts-list.component-DTE5IDW4.css.map */
